import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { ndMenuListItemDirective, ndMenuNavigationDirective } from './menu.directive';
import { ndClickOutsideModule } from 'nd-gui/core';

@NgModule({
  imports: [
    CommonModule,
    ndClickOutsideModule
  ],
  declarations: [
    MenuComponent, 
    ndMenuListItemDirective, 
    ndMenuNavigationDirective
  ],
  exports: [MenuComponent]
})
export class ndMenuModule { }
